module.exports = __webpack_public_path__ + "img/Vendedor.4f3fa9d6.png";